// Skewer. The mirror of a pin: the line's first move puts a slider where it
// attacks a valuable enemy piece (king, queen or rook) with a less valuable
// enemy piece straight behind it on the same ray; when the front piece
// steps aside, the one behind falls. The piece behind is worth taking (not
// a pawn), and the skewering piece is safe where it stands, so the front
// piece cannot simply take it. The variation names the piece in front.
import type { Motif } from '@chess/api-mistakes';
import type { TacticLine } from './line.ts';
import { moved, safe, throughPairs, VALUE } from './rays.ts';

export function skewer(line: TacticLine): Motif | undefined {
  const first = line.pv[0];
  const m = first ? moved(line.board, first) : undefined;
  if (!m || !safe(m.after, m.to)) return undefined;
  const skewers = throughPairs(m.after, m.to).filter(
    ({ front, behind }) =>
      front.colour === line.victim &&
      behind?.colour === line.victim &&
      behind.kind !== 'pawn' &&
      behind.kind !== 'king' &&
      (front.kind === 'king' || front.kind === 'queen' || front.kind === 'rook') &&
      VALUE[front.kind] > VALUE[behind.kind],
  );
  const best = skewers.sort((a, b) => VALUE[b.front.kind] - VALUE[a.front.kind])[0];
  return best ? { family: 'skewer', variation: best.front.kind } : undefined;
}
